import { gql } from '@apollo/client';

// NOTE: Only exists on api's `fdic` branch.
export const SUBMIT_SALE_BID = gql`
  mutation SubmitSaleBid($input: SubmitSaleBidInput!) {
    submitSaleBid(input: $input) {
      __typename
      bid_id
      sale_id
      buyer_company_id
      round
      structure
      version
      offering_ids
      pct_e4
      amount_cents
      received_at
    }
  }
`;
